import styled from 'styled-components'
import Button from 'components/Button'
import FontAwesome from 'react-fontawesome'
import Input from './Input'

const Container = styled.span`
  position: relative;
`

const FormWrapper = styled.div`
  position: absolute;
  width: 365px;
  top: 40px;
  left: 10px;
  background: var(--white);
  padding: 20px;
  border: 1px solid var(--light-gray);
  border-radius: 3px;
  box-shadow: 10px 10px 64px 0px rgba(0, 0, 0, 0.15);
  z-index: 600;
`

const SubmitButton = styled(Button)`
  padding: 7px 25px;
  display: inline-block;
`

const Error = styled.div`
  padding-top: 15px;
`

const FootprintsButton = styled(Button)`
  background: none;
  color: var(--white);
  border-color: var(--white);
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 16px;

  &:hover {
    background: var(--white);
    color: var(--main-color);
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`
const InputWrapper = styled.div`
  width: 210px;
  margin-right: 20px;
  display: inline-block;
  vertical-align: middle;
`

const Search = ({
  handleClick,
  handleSubmit,
  handleBlur,
  searchActive,
  error,
  showFootprint,
  ...inputProps
}) => (
  <>
    {showFootprint === true && (
      <Container onBlur={handleBlur} tabIndex="0">
        <FootprintsButton onClick={handleClick}>
          <FontAwesome name="paw" />
        </FootprintsButton>
        {searchActive && (
          <FormWrapper>
            <form onSubmit={handleSubmit}>
              <InputWrapper>
                <Input {...inputProps} icon="paw" placeholder="Code" />
              </InputWrapper>
              <SubmitButton primary>Search</SubmitButton>
            </form>
            {error && <Error className="text-danger">{error}</Error>}
          </FormWrapper>
        )}
      </Container>
    )}
  </>
)

export default Search
